import { VisuallyHidden as ChakraVisuallyHidden } from '@chakra-ui/react';
import { useStableCallback } from '@main/shared/browser';
import { useEffect } from 'react';

const MESSAGE_LIFETIME = 5000;

/** A polite live region that empties itself, so the same message can be spoken twice. */
export function LiveMessage({ message, onClear }: { message: string; onClear: () => void }) {
  const stableOnClear = useStableCallback(onClear);
  useEffect(() => {
    if (!message) return;
    const timeout = setTimeout(stableOnClear, MESSAGE_LIFETIME);
    return () => clearTimeout(timeout);
  }, [message, stableOnClear]);

  // Parked until ComplyKit has visually hidden text (component-map.md): the
  // vocabulary has no successor yet, and a styled plain element is not an escape.
  return (
    <ChakraVisuallyHidden role="status" aria-live="polite">
      {message}
    </ChakraVisuallyHidden>
  );
}
